import React, { useEffect } from 'react'
import url from 'libraries/front-end-core/core/url'
import { QA_REVIEW } from 'constants/controllers'
import { URL_PDF_QA } from 'constants/urls'
import { of, Subject } from 'rxjs'
import { map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators'
import { deselectContent, observeSelected } from 'libraries/front-end-core/services/StateService'
import { observePageState } from 'libraries/front-end-core/services/PageStateService'
import { requestSectionContent } from 'services/QAService'
import { flatten, pick, reduce, result, values } from 'libraries/lodash'
import { shorten } from 'libraries/front-end-core/services/ShortenerService'
import SelectedHeader from 'components/shared/SelectedHeader'
import { useSelector } from 'react-redux'
import selectFlavour from 'redux/selectors/selectFlavour'
import TitleContainer from 'redux/containers/components/qa/TitleContainer'
import selectAolName from 'redux/selectors/selectAolName'

const findSectionId = (state) => {
  // TODO refactor this into something that's actually readable
  return reduce(state, (result, v, k) => (k.match(/\//g) || []).length === 2 && v > 0 && k || result, '').split('/')[1] || '' // eslint-disable-line
}

const mapSectionContent = (sectionId, resp) => {
  const descendants = result(resp, ['nodes', sectionId, 'descendants'], [])
  const pickedSections = pick(resp.sections, descendants)
  return {
    ids: flatten(values(pickedSections)) || [],
    sectionId
  }
}

const findSelectedIds = (state, selected) => {
  return Object.assign(state, {
    selectedIds: (selected && state.ids.map(id => (selected[id] && id) || null).filter(x => !!x)) || [],
    short: null
  })
}

const Header = (props) => {
  const flavour = useSelector(selectFlavour)
  const aol = useSelector(selectAolName)

  // evaluate the id of expanded section
  const ExpandedSectionId = observePageState().pipe(
    debounceTime(5),
    map(findSectionId),
    distinctUntilChanged()
  )

  // find all leaf ids of the section
  const ContentIds = ExpandedSectionId.pipe(
    switchMap(
      sectionId => {
        return requestSectionContent(flavour, sectionId, aol).pipe(
          map((response) => mapSectionContent(sectionId, response))
        )
      }
    )
  )

  // find which leaves are selected
  const SelectedIds = ContentIds.pipe(
    switchMap(
      state => {
        return observeSelected(flavour).pipe(
          map(findSelectedIds.bind(null, state))
        )
      }
    ),
    switchMap(
      state => {
        const { sectionId, selectedIds } = state
        return sectionId && selectedIds && selectedIds.length
          ? shorten(url(QA_REVIEW, { flavour, sectionId, selectedIds, aol }).replace(/#/, '')).pipe(
            map(short => Object.assign(state, { short })))
          : of(state)
      }
    )
  )

  const subject = new Subject()

  const subscription = SelectedIds.asObservable().subscribe((response) => {
    subject.next(response)
  })

  useEffect(() => {
    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return (
    <div>
      <SelectedHeader
        {...props}
        stateSource={subject}
        deselectAll={deselectContent.bind(null, flavour)}
        keyword={(l) => l === 1 ? 'question' : 'questions'}
        pdfUrl={URL_PDF_QA}
        dataHelpItem='qatoolbar'
      />
      <TitleContainer {...props} />
    </div>
  )
}

export default Header
